import { Checkbox, Group, Image, Text, TextInput } from "@mantine/core";
import { EditableField } from "./EditableField";
import { DateTimePicker } from "@mantine/dates";
import { ImageFieldUpload } from "../../services/data/values/ImageFieldUpload";
import { localDateTimeToISO } from "../../../../utils/datetime";

export const CustomFieldsWithEditableValue = ({
  fields,
  loading,
  defaultValues,
  onSubmit,
}: {
  fields: {
    name: string;
    type: string;
    property: string;
  }[];
  loading?: boolean;
  defaultValues?: Record<string, any>;
  onSubmit: (property: string, value: any) => void;
}) => {
  return fields.map((field, idx) => (
    <Group key={idx} gap={5}>
      <Text span fw={700}>
        {field.name}:
      </Text>{" "}
      <EditableField
        loading={loading}
        readingElement={({ value }) =>
          field.type === "IMAGE" && value ? (
            <Image src={value} alt={field.name} maw={200} radius="md" />
          ) : (
            (field.type === "BOOLEAN" && (
              <>{value === "true" ? "Yes" : "No"}</>
            )) || <Text span>{JSON.stringify(value)}</Text>
          )
        }
        editingElement={({ value, onChange, disabled }) =>
          field.type === "STRING" ? (
            <TextInput
              disabled={disabled}
              type="text"
              value={value}
              onChange={(e) => onChange(e.target.value)}
            />
          ) : field.type === "DATE" ? (
            <DateTimePicker
              value={value || null}
              onChange={(val) => onChange(localDateTimeToISO(val))}
              disabled={disabled}
            />
          ) : field.type === "BOOLEAN" ? (
            <Checkbox
              disabled={disabled}
              checked={value === "true"}
              onChange={(event) =>
                onChange(event.currentTarget.checked ? "true" : "false")
              }
            />
          ) : field.type === "IMAGE" ? (
            <ImageFieldUpload
              value={value}
              onChange={onChange}
              onImmediateSave={async (val) => onSubmit(field.property, val)}
              objectType="custom"
              fieldKey={field.property}
            />
          ) : (
            <TextInput
              disabled={disabled}
              type="text"
              value={value}
              onChange={(e) => onChange(e.target.value)}
            />
          )
        }
        defaultValue={defaultValues?.[field.property]}
        onSubmit={async (value) => onSubmit(field.property, value)}
      />
    </Group>
  ));
};
